<!--
 * @Description: 商户审核结果组件
 * @Author: gaohc
 * @Date: 2022-11-02 14:01:35
 * @LastEditTime: 2022-11-07 16:49:28
-->
<template>
  <!-- 审核状态：0-未审核 1-审核通过 2-审核拒绝 3-撤回	 -->
  <div class="mch-review-history-wrap">
    <el-row class="row-bg review-btn-wrap" type="flex" justify="space-between">
      <el-col class="review-user" :span="6">
        <span>提交人：</span>
        <span>{{ review.submiterText ? review.submiterText : "- -" }}</span>
      </el-col>
      <el-col :span="8">
        <span>提交时间： </span>
        <span>{{ review.submitTime ? review.submitTime : "- -" }}</span>
      </el-col>
      <el-col :span="10" style="text-align: right">
        <span class="status-button adopt-btn" @click="handleReviewPass">
          <img class="review-icon" src="@/assets/reviewmng/icon-attendant-review-list-pass.png" 
		  	  alt=""/>
          <span style="margin-left: 2px">通 过</span>
        </span>
        <span v-if="review.status != 2" class="status-button" @click="handleReviewReject"
		      style="background: #e04a52; cursor: pointer">
          <img class="review-icon" src="@/assets/reviewmng/icon-attendant-review-list-nopass.png"
            alt=""/>
          <span style="margin-left: 2px">驳 回</span>
        </span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "MchReviewResult",
  props: ["review", "isGlobalAdmin"],
  methods: {
    handleReviewPass() {
      this.$emit("handle-review", "approve", this.review.version);
    },

    handleReviewReject() {
      this.$emit("handle-review", "reject", this.review.version);
    }
  },
};
</script>

<style scope>
.mch-review-history-wrap {
  background: #f7f9fe;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  padding: 20px 40px 20px 30px;
}

.review-btn-wrap {
  align-items: center;
  color: #525254;
  font-size: 15px;
}

.review-user {
  padding-right: 10px;
}

.status-button {
  display: inline-block;
  width: 98px;
  height: 31px;
  border-radius: 2px;
  text-align: center;
  line-height: 31px;
  font-size: 15px;
  font-weight: 400;
  color: #ffffff;
}

.review-icon {
  width: 18px;
  height: 20px;
  vertical-align: middle;
}

.adopt-btn {
  background: #3e7ef6;
  cursor: pointer;
  margin-right: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/review/components/mchReviewList/MchReviewResult.vue